import React, { useState } from 'react';

const Slider2Modal = ({
  isOpen,
  setIsOpen,
  inputValue,
  handleInputChange,
  inputValuelink,
  handleInputChangeLink,
  handleFileChange,
  handleAddAmenities,
  imagePreview,
  setImagePreview
}) => {
  
  const [linkError, setLinkError] = useState("");
  const [imageError, setImageError] = useState("");

  if (!isOpen) return null;

  const onFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedExtensions = ['jpeg', 'jpg', 'png', 'webp', 'avif'];
      const extension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        setImageError("Only jpeg, jpg, png, webp, avif formats are allowed.");
        setImagePreview(null);
        return;
      }

      if (file.size > 1024 * 1024) {
        setImageError("Image size must be less than 1MB");
        setImagePreview(null);
        return;
      }

      setImageError("");
      setImagePreview(URL.createObjectURL(file));
      handleFileChange(e);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // if (inputValuelink.trim() && !/^https?:\/\//.test(inputValuelink.trim())) {
    //   setLinkError("Link must start with http:// or https://");
    //   return;
    // } else {
    //   setLinkError("");
    // }

    if (imageError) return;

    handleAddAmenities();
  };

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Our Slider</h2>
        <form className="oms-modal-form" onSubmit={onSubmit}>

          {/* Title */}
          {/* <div className="oms-form-group">
            <label htmlFor="title" className="oms-form-label">Title</label>
            <input
              type="text"
              id="title"
              name="title"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Enter title"
              required
            />
          </div> */}

          {/* Link */}
          {/* <div className="oms-form-group">
            <label htmlFor="link" className="oms-form-label">Link a Page</label>
            <input
              type="text"
              id="link"
              name="link"
              value={inputValuelink}
              onChange={handleInputChangeLink}
              placeholder="Enter link"
            />
            {linkError && <p style={{ color: 'red', fontSize: '14px', marginTop: "5px", marginLeft: "5px" }}>{linkError}</p>}
          </div> */}

          {/* Image Upload */}
          <div className="oms-form-group">
            <label htmlFor="image" className="oms-form-label">Upload Image</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={onFileChange}
              required
            />
            {imageError && <p style={{ color: 'red', fontSize: '14px', marginTop: "5px", marginLeft: "5px" }}>{imageError}</p>}
            {imagePreview && (
              <div className="oms-image-preview" style={{ marginTop: '10px' }}>
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{ width: '100%', maxHeight: '150px', objectFit: 'contain' }}
                />
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="oms-form-actions">
            <button type="button" onClick={() =>{ setIsOpen(false)
              setImagePreview("")
            }}>Cancel</button>
            <button type="submit">Submit</button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default Slider2Modal;
